import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ButtonComponent from '#app/Component/ButtonComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Filters } from '#app/View/Sale/OrderClient/SaleOrderClientList/hooks/useOrderClientList';
import useCarriers from '#app/hooks/useCarriers';
import { ChannelSelects } from '#app/typings/channel';
import { OrderClientState, OrderClientStateSelects } from '#app/typings/orderClient';

type Props = {
  handleSearch: (data: Filters) => void;
  filters: Partial<Filters>;
};

const Search: React.FC<Props> = ({ handleSearch, filters }) => {
  const classes = useStyles();
  const { orderClientState } = useParams();
  const { carriers } = useCarriers();

  const [formSearch, setFormSearch] = useState<Form>({
    number: {
      name: 'number',
      label: 'Référence',
      textHelper: 'Rechercher par référence.',
      type: 'text',
      defaultValue: filters?.number,
    },
    numberCarrier: {
      name: 'numberCarrier',
      label: 'Num suivi colis',
      textHelper: 'Rechercher par suivi.',
      type: 'text',
      defaultValue: filters?.numberCarrier,
    },
    email: {
      name: 'email',
      label: 'Email',
      textHelper: 'Rechercher par email.',
      type: 'text',
      defaultValue: filters?.email,
    },
    name: {
      name: 'name',
      label: 'Client',
      textHelper: 'Rechercher par client.',
      type: 'text',
      defaultValue: filters?.name,
    },
    numberSylius: {
      name: 'numberSylius',
      label: 'Id sylius',
      textHelper: 'Rechercher par id sylius.',
      type: 'text',
      defaultValue: filters?.numberSylius,
    },
    channels: {
      name: 'channels',
      label: 'Canal',
      textHelper: 'Rechercher par canaux.',
      type: 'array',
      defaultValue: filters?.channels,
    },
    orderClientStates: {
      name: 'orderClientStates',
      label: 'État de la commande',
      textHelper: 'Rechercher par état.',
      type: 'array',
      defaultValue: filters?.orderClientStates,
    },
    carriers: {
      name: 'carriers',
      label: 'Transporteur',
      textHelper: 'Rechercher par transporteur.',
      type: 'array',
      defaultValue: filters?.carriers,
    },
  });

  const handlerForm = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerForm.start();
  }, []);
  useEffect(() => {
    handlerForm.reset();
    handlerForm.setValue(
      'orderClientStates',
      orderClientState && Object.values(OrderClientState).includes(parseInt(orderClientState))
        ? [orderClientState]
        : [],
    );
  }, [orderClientState]);

  const getData = (): Filters => {
    const data = handlerForm.getData();
    return {
      number: data.number,
      numberCarrier: data.numberCarrier,
      email: data.email,
      name: data.name,
      numberSylius: data.numberSylius,
      channels: data.channels,
      orderClientStates: data.orderClientStates,
      carriers: data.carriers,
    };
  };

  return (
    <ShadowBoxComponent className={classes.container}>
      <Grid container>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="number" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="numberCarrier" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="email" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="name" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <TextFieldComponent id="numberSylius" handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="channels" options={ChannelSelects} handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent withSelectAll id="carriers" options={carriers} handler={handlerForm} />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <MultipleSelectComponent
            withSelectAll
            id="orderClientStates"
            options={OrderClientStateSelects}
            handler={handlerForm}
          />
        </Grid>
        <ButtonComponent label="Rechercher" onClick={() => handleSearch(getData())} />
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  container: {
    marginBottom: 20,
  },
});

export default Search;
